// import Index from '../../views/Index.vue'
import PanoEdit from '../../views/PanoEdit.vue'
import PanoEditBasic from '../../views/PanoEditBasic.vue'
import PanoEditView from '../../views/PanoEditView.vue'
import PanoEditHotPoint from '../../views/PanoEditHotPoint.vue'
import PanoEditSandTable from '../../views/PanoEditSandTable.vue'
import PanoEditModel from '../../views/PanoEditModel.vue'
import PreView from '../../views/PreView.vue'
import PreViewWithOutModel from '../../views/PreViewWithOutModel.vue'
import PanoViewMobileModel from '../../views/PanoViewMobileModel.vue'
import PanoViewMobile from '../../views/PanoViewMobile.vue'
import PreView_O from '../../views/PreView_O.vue'
import DragTest from '../../views/DragTest.vue'
import VideoView from '../../views/VideoView.vue'
import music from '../../views/music.vue'

export default [{
  path: '/panoedit',
  name: '全景图编辑页面',
  component: PanoEdit,
  children: [{
    path: 'basic',
    name: 'basic',
    component: PanoEditBasic
  },
  {
    path: 'music',
    name: 'music',
    component: music
  },
  {
    path: 'view',
    name: 'view',
    component: PanoEditView
  },
  {
    path: 'hotpoint',
    name: 'hotpoint',
    component: PanoEditHotPoint
  },
  {
    path: 'sandtable',
    name: 'sandtable',
    component: PanoEditSandTable
  },
  {
    path: 'model',
    name: 'model',
    component: PanoEditModel
  }
  ]
},
{
  path: '/previewwidthoutmodel',
  name: '无模型全景图预览页面',
  component: PreViewWithOutModel
},
{
  path: '/preview',
  name: '全景图预览页面',
  component: PreView
},
{
  path: '/VideoView',
  name: '全景视频预览页面',
  component: VideoView
},
{
  path: '/pvmm',
  name: '全景图模型展示页面',
  component: PanoViewMobileModel
},
{
  path: '/pvm',
  name: '全景图展示页面',
  component: PanoViewMobile
},
{
  path: '/preview_o',
  name: '全景图预览页面',
  component: PreView_O
},
{
  path: '/dragtest',
  name: 'vue拖动排序测试',
  component: DragTest
}
]
